import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ErrorContextType {
  has403Error: boolean;
  setHas403Error: (hasError: boolean) => void;
  reset403Error: () => void;
  errorMessage: string;
  setErrorMessage: (message: string) => void;
}

const ErrorContext = createContext<ErrorContextType>({
  has403Error: false,
  setHas403Error: () => {},
  reset403Error: () => {},
  errorMessage: '',
  setErrorMessage: () => {},
});

export const useError = () => {
  return useContext(ErrorContext);
};

interface ErrorProviderProps {
  children: ReactNode;
}

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [has403Error, setHas403Error] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  const reset403Error = () => {
    setHas403Error(false);
    setErrorMessage('');
  };

  return (
    <ErrorContext.Provider value={{
      has403Error,
      setHas403Error,
      reset403Error,
      errorMessage,
      setErrorMessage,
    }}>
      {children}
    </ErrorContext.Provider>
  );
};
